/* =========================================================
   REAPERRAGS · theme.js
   Header scroll, mobile menu, countdown, gallery, AJAX cart
   ========================================================= */

(function() {
  'use strict';

      /* ===== COUNTDOWN TIMER ===== */
  function nextDrop() {
    var cfg = window.reaper || {};
    var dropDay = parseInt(cfg.drop_day) || 5;
    var dropHour = parseInt(cfg.drop_hour) || 20;
    var dropMin = parseInt(cfg.drop_minute) || 30;

    var now = new Date();
    var d = new Date(now);
    var day = d.getDay();
    var add = (dropDay - day + 7) % 7;
    if (add === 0) {
      var sameDayTarget = new Date(d);
      sameDayTarget.setHours(dropHour, dropMin, 0, 0);
      if (now > sameDayTarget) add = 7;
    }
    d.setDate(d.getDate() + add);
    d.setHours(dropHour, dropMin, 0, 0);
    return d;
  }

  var target = nextDrop();
  var pad = function(n) { return String(n).padStart(2, '0'); };

  function tick() {
    var now = new Date();
    var diff = Math.max(0, target - now);
    var days = Math.floor(diff / 86400000); diff -= days * 86400000;
    var hrs = Math.floor(diff / 3600000); diff -= hrs * 3600000;
    var min = Math.floor(diff / 60000); diff -= min * 60000;
    var sec = Math.floor(diff / 1000);
    var str = pad(days) + 'D · ' + pad(hrs) + ':' + pad(min) + ':' + pad(sec);

    var cd = document.getElementById('cd');
    if (cd) {
      cd.textContent = str;
      cd.setAttribute('aria-label', days + ' days, ' + hrs + ' hours, ' + min + ' minutes, ' + sec + ' seconds until next drop');
    }

    var lockCd = document.getElementById('lockCountdown');
    if (lockCd) lockCd.textContent = pad(days) + ':' + pad(hrs) + ':' + pad(min) + ':' + pad(sec);
  }
  tick();
  setInterval(tick, 1000);

  /* ===== STOCK DRAIN (configurable) ===== */
  var cfg = window.reaper || {};
  if (cfg.stock_drain !== false) {
    var leftEl = document.getElementById('leftCount');
    if (leftEl) {
      var stockLeft = parseInt(leftEl.textContent) || 23;
      setInterval(function() {
        if (stockLeft <= 1) return;
        if (Math.random() < 0.35) {
          stockLeft--;
          leftEl.textContent = stockLeft;
          leftEl.style.color = '#ff3030';
          setTimeout(function() { leftEl.style.color = '#fff'; }, 800);
        }
      }, 8000);
    }
  }

  /* ===== PDP GALLERY THUMBNAILS ===== */
  var thumbs = document.querySelectorAll('.thumb[data-img]');
  var mainImg = document.getElementById('mainImg');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb, idx) {
      // Make thumbs keyboard accessible
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', 'View image ' + (idx + 1));

      function activateThumb() {
        thumbs.forEach(function(t) { t.classList.remove('active'); t.setAttribute('aria-pressed', 'false'); });
        thumb.classList.add('active');
        thumb.setAttribute('aria-pressed', 'true');
        mainImg.src = thumb.getAttribute('data-img');
        mainImg.alt = thumb.getAttribute('data-alt') || 'Product image ' + (idx + 1);
      }

      thumb.addEventListener('click', activateThumb);
      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateThumb();
        }
      });
    });
  }

  /* ===== PDP ACCORDIONS KEYBOARD ===== */
  var accHeaders = document.querySelectorAll('.acc-header');
  accHeaders.forEach(function(h) {
    h.setAttribute('role', 'button');
    h.setAttribute('tabindex', '0');
    var panel = h.nextElementSibling;
    var id = 'acc-panel-' + Math.random().toString(36).substr(2, 9);
    if (panel) {
      panel.id = id;
      h.setAttribute('aria-controls', id);
      h.setAttribute('aria-expanded', h.classList.contains('active') ? 'true' : 'false');
    }
    h.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        h.click();
      }
    });
    h.addEventListener('click', function() {
      var expanded = h.getAttribute('aria-expanded') === 'true';
      h.setAttribute('aria-expanded', !expanded);
    });
  });

  /* ===== AJAX ADD TO CART ===== */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var btn = productForm.querySelector('.add-btn');
      if (btn) {
        btn.textContent = 'ADDING...';
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      }

      fetch(window.reaper.routes.cart_add_url + '.js', {
        method: 'POST',
        body: formData
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (btn) {
          btn.textContent = '✓ ADDED — VIEW BAG';
          btn.setAttribute('aria-busy', 'false');
          btn.disabled = false;
        }
        // Announce to screen readers
        announceToSR('Item added to bag successfully');
        // Update cart count
        var counts = document.querySelectorAll('.cart-count');
        fetch(window.reaper.routes.cart_url + '.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            counts.forEach(function(c) { c.textContent = '(' + cart.item_count + ')'; });
          });
        setTimeout(function() {
          if (btn) btn.textContent = 'ADD TO BAG · ' + item.final_line_price_formatted;
        }, 3000);
      })
      .catch(function() {
        if (btn) {
          btn.textContent = 'ERROR — TRY AGAIN';
          btn.setAttribute('aria-busy', 'false');
          btn.disabled = false;
        }
        announceToSR('Error adding item to bag. Please try again.');
        setTimeout(function() {
          if (btn) btn.textContent = 'ADD TO BAG';
        }, 2000);
      });
    });
  }

  /* ===== LIVE REGION FOR SCREEN READER ANNOUNCEMENTS ===== */
  function announceToSR(message) {
    var live = document.getElementById('sr-live-region');
    if (!live) {
      live = document.createElement('div');
      live.id = 'sr-live-region';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('aria-atomic', 'true');
      live.className = 'sr-only';
      document.body.appendChild(live);
    }
    live.textContent = message;
  }

  /* ===== SMOOTH SCROLL (respects reduced motion) ===== */
  var smoothLinks = document.querySelectorAll('a[href^="#"]');
  smoothLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      var targetId = link.getAttribute('href').slice(1);
      var el = document.getElementById(targetId);
      if (el) {
        e.preventDefault();
        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        el.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth' });
        el.focus({ preventScroll: true });
      }
    });
  });

})();
